import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../auth/login/login.service';
import { MyDataService } from '../../data/data.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(
    private http: HttpClient,
    public router: Router,
    private loginSvc: LoginService,
    private dataSvc: MyDataService,
    private translocoService: TranslocoService
  ) {}

  comprobarClienteChangePass(hashOrUserID: string | number, codigo?: string): Observable<any> {
    return new Observable<any>((observer) => {
      let body: any;
      
      // Si se proporciona codigo, usar userID + codigo, sino usar hash
      if (codigo !== undefined) {
        body = {
          userID: hashOrUserID,
          codigo: codigo
        };
      } else {
        body = { hash: hashOrUserID };
      }

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/comprobar-cliente-change-password',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(true);
          },
          (err) => {
            console.log('Error al comprobar cambio contraseña: ', err);
            observer.error(err.message);
          }
        );
    });
  }

  changePass(hashOrUserID: string | number, newPass: string, codigo?: string): Observable<any> {
    return new Observable<any>((observer) => {
      let body: any;
      
      // Si se proporciona codigo, usar userID + codigo + newPass, sino usar hash + newPass
      if (codigo !== undefined) {
        body = {
          userID: hashOrUserID,
          codigo: codigo,
          newPass: newPass
        };
      } else {
        body = { 
          hash: hashOrUserID, 
          newPass: newPass 
        };
      }

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/change-password-area-cliente',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(true);
          },
          (err) => {
            console.log('Error cambio contraseña: ', err);
            observer.error(err.message);
          }
        );
    });
  }

  sendMailCambioContraseña(email: string): Observable<any> {
    return new Observable<any>((observer) => {
      const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
      const lang = this.translocoService.getActiveLang(); // idioma actual
      const logo = this.dataSvc.getLogo();
      const logo2 = this.dataSvc.getLogo2();
      const logo3 = this.dataSvc.getLogo3();

      const body = {
        email,
        proyectoPlatform,
        lang,
        logo,
        logo2,
        logo3
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/send-mail-cambio-password',
          body,
          options
        )
        .subscribe(
          (response: any) => observer.next(response),
          (err) => {
            console.log('Error enviar correo cambio contraseña: ', err);
            observer.error(err.message);
          }
        );
    });
  }





}
